import React, { FC } from 'react';

interface TagProps {
  label: string;
  onRemove: () => void;
}

const Tag: FC<TagProps> = ({ onRemove, label }) => {
  return (
    <div className="h-7 px-3 py-1 bg-navy-50 rounded-3xl border border-navy-100 justify-center items-center gap-1.5 inline-flex">
      <div className="text-navy-700 text-subtitle3a">{label}</div>
      <i
        className="ri-close-circle-line text-[#303030] hover:text-red-400 cursor-pointer"
        role="presentation"
        onClick={onRemove}
      />
    </div>
  );
};

export default Tag;
